import styled from '@emotion/styled';
import { style } from '@app/shared/lib/Style';

export default styled.p({
    fontSize: style.fontSize.epsilon,
    fontWeight: style.fontWeight.bold,
    color: style.colors.secondary
});
